import "core-js/modules/es.array.concat.js";
import React from 'react';
import { AppLink } from '@finect/tabular-core/AppLink';
import { useTheme } from 'styled-components';
import { getFundsCategoryPath } from '@finect/front-resources/Products';
import { Tag } from '../../Tags';
export var CategoryTag = function CategoryTag(props) {
  var entity = props.entity,
    productType = props.productType;
  var theme = useTheme();
  return React.createElement(AppLink, {
    href: getFundsCategoryPath(theme, productType, entity),
    title: "Ver ".concat(productType.shortPlural, " de la categor\xEDa ").concat(entity.name, " de ").concat(entity.provider)
  }, React.createElement(Tag, {
    withMargin: true
  }, entity.name));
};